var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExceptionStoreStandard = function SvgExceptionStoreStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20a7.926 7.926 0 002.36 5.64l-1.51 1.51a.5.5 0 00.36.85h4.29a.495.495 0 00.5-.5v-4.29a.495.495 0 00-.85-.35l-1.39 1.39a6.003 6.003 0 011.67-9.67.935.935 0 00.57-.84v-.19a.917.917 0 00-1.32-.82A7.99 7.99 0 0011 20zm8 5h2v-2h-2zm8.79-13H23.5a.495.495 0 00-.5.5v4.29a.495.495 0 00.85.35l1.39-1.39a6.003 6.003 0 01-1.67 9.67.935.935 0 00-.57.84v.18a.917.917 0 001.32.82 7.95 7.95 0 002.32-12.9l1.51-1.51a.5.5 0 00-.36-.85zM20 21a1.003 1.003 0 001-1v-4a1 1 0 00-2 0v4a1.003 1.003 0 001 1z",
    fill: "#fabc3c"
  })));
};
export default SvgExceptionStoreStandard;